import { fetcher } from '../utils'

export default async (value: boolean): Promise<void> => fetcher(`/api/user/available/${value}`, 'POST', {})
